import { AnyZodObject, z, ZodFirstPartySchemaTypes, ZodNullable, ZodOptional, ZodTypeAny } from 'zod';

type StripNullable<T extends ZodTypeAny> = T extends ZodNullable<any> ? T['_def']['innerType'] : T;

type StripOptional<T extends ZodTypeAny> = T extends ZodOptional<any> ? T['_def']['innerType'] : T;

// :)
// I cant assure the order, but I can assure that it's at most 2 layers, so just try twice!
export type StripWrappers<T extends ZodTypeAny> = StripNullable<StripOptional<StripNullable<StripOptional<T>>>>;

export const requiredZodString = (field: string) =>
  z
    .string({
      required_error: `${field} is required`,
      invalid_type_error: `${field} is required`,
    })
    .min(1, `${field} is required`);

export const isNullable = (type) => {
  const typeName = type._def.typeName;
  return typeName === 'ZodNullable' || typeName === 'ZodOptional';
};

const descend = (type: ZodFirstPartySchemaTypes) => {
  if (isNullable(type)) {
    return descend(type._def?.['innerType']);
  }
  return type;
};

export const getRealType = (type): [ZodFirstPartySchemaTypes['_type'], ZodFirstPartySchemaTypes['_def']] => {
  const deepType = descend(type);
  return [deepType._def.typeName, deepType._def];
};

export const autoCoerce = <T extends AnyZodObject>(type: T) => {
  const copy = type._def.shape();

  for (const key in copy) {
    const realType = descend(copy[key]);

    if (realType._def?.['coerce'] === false) {
      realType._def['coerce'] = true;
    }
  }

  return z.object({ ...copy }) as T;
};

export const addressSchema = z.object({
  recipient: z.string().nullish().default(null),
  line_one: z.string().nullish().default(null),
  line_two: z.string().nullish().default(null),
  city: z.string().nullish().default(null),
  state: z.string().nullish().default(null),
  zip_code: z.string().nullish().default(null),
  country: z.string().nullish().default(null),
});
